
const SPA_BACKEND_DOMAIN = "zxdata.zanbato.com";
export { SPA_BACKEND_DOMAIN };
const SPA_BACKEND_URL = "https://zxdata.zanbato.com";
export { SPA_BACKEND_URL };

const SPA_FRONTEND_DOMAIN = "zxdata.zanbato.com";
export { SPA_FRONTEND_DOMAIN };
const SPA_FRONTEND_URL = "https://zxdata.zanbato.com";
export { SPA_FRONTEND_URL };

const SPA_ASSETS_PREFIX = "/assets/";
export { SPA_ASSETS_PREFIX };
